export default __webpack_public_path__ + "static/media/icon_sapphire.820b71c8.png";